// extracted by mini-css-extract-plugin
module.exports = {"root":"DummyTopbar_root__SQIWt","logoDesktop":"DummyTopbar_logoDesktop__2b9_Y"};